
import { prototype } from 'module';

<!-- eslint-disable vue/no-use-v-if-with-v-for -->
<template>
  <tr>
    <td class="name-column" style="white-space: nowrap">
      {{name}} <span v-if='defaultvalue !== null'> = {{defaultvalue}}</span>
      <span v-if='!parent || !parent.isEnum'><badge :label="b" v-for="b in badges" :key='b' /></span>
    </td>
    <td class="type-column" v-if="!noType">
      <div v-if='!parent || !parent.isEnum' v-html='type'/>
    </td>
    <td class="description-column">
      <div class='clpp-api-description detail-summary' v-html="description" v-if='description'>{{description}}</div>

      <div v-if="defaultvalue !== null && (!parent || !parent.isEnum)">
        <span class='clpp-api-label'>Default:</span> <span class='defaultvalue'>{{defaultvalue}}</span>
      </div>

      <div v-if='(!parent || !parent.isEnum) && embedType'>
        <span class='clpp-api-label'>Type:</span> <span v-html='type'/>
      </div>

      <div v-if='properties.length' class="v-space clpp-api-prop-table">
        <table>
          <thead>
            <tr>
              <th class="name-header-column">Name</th>
              <th class="">Description</th>
            </tr>
          </thead>
          <DocsDetailParameter v-for='p in properties'
                               :key='p.name'
                               :entry='p' :parent='entry'
                               :embed-type="true"
                               :no-type="true"/>
        </table>
      </div>
    </td>
  </tr>
</template>

<script>
import { DocsComponentMixin } from '../../utils/docs';
import Badge from '../Badge.vue';

/**
 * Takes a parameter or property entry from JSDocs DB and an optional parent and
 * renders the parameter or property.
 *
 * The rendering covers:
 *
 *  * The name
 *  * The default value rendered in the name, i.e. <name> = <default>
 *  * The type, if the parent is not an enum (in which case the parent will render the type)
 *  * The default value separately unless the parent is an enum
 */
export default {
  components: { Badge },
  mixins: [DocsComponentMixin],

  name: 'DocsDetailParameter',
  props: {
    noType: {
      type: Boolean,
      default: false
    },
    embedType: {
      type: Boolean,
      default: false
    }
  }
};
</script>
